import React from "react";

const FLAG_KINDS = ["green", "neon", "red", "orange"];

const StatusFlag = ({kind, title}) => {
    if (FLAG_KINDS.indexOf(kind) === -1) return null;
    return (
        <img className={`StatusFlag StatusFlag--${kind}`}
             src={`/img/flag-pin-${kind}.svg`}
             alt={title}
             title={title}
             width="32"
             height="32"
             style={{display: "block", margin: "0 auto"}}/>
    );
};

export default StatusFlag;
